<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">옵션상품</span>
      <button class="btn-pop-close" @click="$.emit('close')">
        닫기<span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <div class="fieldset mt-comm">
        <!-- <span class="h2">옵션상품</span> -->
        <div class="ip-row">
          <label for="memCloud">총 옵션금액</label>
          <!-- 기본 포커스 스타일 제거, 포커스 효과: 아래 요소에 on 클래스 추가 -->
          <input
            type="text"
            class="ip-comm"
            id="memCloud"
            :value="totalUprc"
            disabled
          />
        </div>
      </div>
      <div class="lst-option-wrap admin-mt12">
        <div class="lst-option">
          <!-- page 1 -->
          <!-- type02: paging 없음 -->
          <div class="lst-option--col type01">
            <div
              class="box--bdr"
              v-for="(option, index) in optionList.slice(
                (optionCurrentPage - 1) * optionPageCount,
                optionCurrentPage * optionPageCount
              )"
              :key="index"
              :class="{ on: activeOption == index }"
              @click="optionDetail(option, index)"
            >
              <div class="box--hdr">{{ option.optClasNm }}</div>
              <div class="box--body ellipsis02">
                {{
                  option.selectItemNm == null ? "선택안함" : option.selectItemNm
                }}
              </div>
              <div class="box--ftr">
                {{
                  option.selectItemPrice == null
                    ? "+ 0"
                    : "+ " + option.selectItemPrice
                }}
              </div>
            </div>
          </div>
          <!-- //page 1 -->
          <div class="posi-btn">
            <button
              class="swipe-btn-up"
              :disabled="optionCurrentPage == 1"
              @click="
                optionCurrentPage--;
                activeOption = 0;
              "
            >
              위로<span class="overlay"></span>
            </button>

            <button
              class="swipe-btn-down"
              :disabled="
                optionCurrentPage ==
                Math.ceil(this.optionCount / optionPageCount)
              "
              @click="
                optionCurrentPage++;
                activeOption = 0;
              "
            >
              아래로<span class="overlay"></span>
            </button>
          </div>

          <div class="swiper-pagination--col">
            <span
              class="bullet"
              v-for="(number, index) in Math.ceil(
                this.optionCount / optionPageCount
              )"
              :key="index"
              :class="{ on: optionCurrentPage == index + 1 }"
              @click="
                optionCurrentPage = index + 1;
                activeOption = 0;
              "
            >
            </span>
          </div>
        </div>

        <div class="lst-option">
          <!-- 바둑판 형 리스트: type은 박스 사이즈 -->
          <!-- page 1 -->
          <div class="lst-option--grid type01">
            <div
              class="box--shd"
              v-for="item in itemList.slice(
                (itemCurrentPage - 1) * itemPageCount,
                itemCurrentPage * itemPageCount
              )"
              :key="item"
              :class="{
                on:
                  this.optionList[
                    (optionCurrentPage - 1) * optionPageCount + activeOption
                  ].selectItemCd == item.optItemCd,
              }"
              @click="selectItem(item)"
            >
              <span class="box--hdr">{{ item.presetNm }}</span>
              <span class="box--ftr">{{ item.saleUprc }}</span>
            </div>

            <!-- <div class="box--shd nodata"></div>
                        <div class="box--shd nodata"></div> -->
          </div>
          <!-- // page 1 -->
          <div class="swipe-btn-area">
            <button
              class="swipe-btn-prev"
              :disabled="itemCurrentPage == 1"
              @click="itemCurrentPage--"
            >
              이전<span class="overlay"></span>
            </button>

            <button
              class="swipe-btn-next"
              :disabled="
                itemCurrentPage == Math.ceil(this.itemCount / itemPageCount)
              "
              @click="itemCurrentPage++"
            >
              다음<span class="overlay"></span>
            </button>
          </div>
          <div class="swiper-pagination">
            <span
              class="bullet"
              v-for="(number, index) in Math.ceil(
                this.itemCount / itemPageCount
              )"
              :key="index"
              :class="{ on: itemCurrentPage == index + 1 }"
              @click="itemCurrentPage = index + 1"
            >
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 버튼이 두개인 경우에 아래 요소에 클래스명 btn02 추가 -->
    <div class="pop-btn-area btn02">
      <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
      <button
        type="button"
        class="btn-pop btn-half btn-main"
        @click="initOptionList"
      >
        초기화<span class="overlay"></span>
      </button>
      <button
        type="button"
        class="btn-pop btn-half btn-submit"
        @click="setBaskets"
      >
        완료<span class="overlay"></span>
      </button>
    </div>
  </div>
</template>

<script>
//json
import jsonTbMstItem from "@/assets/json/TbMstItem.js";
import jsonTbMstOpt from "@/assets/json/TbMstOpt.js";

export default {
  name: "menuOption",
  data() {
    return {
      //옵션 관련 data들
      mstOptionList: jsonTbMstOpt.data.mstOptionList,
      optionList: [],
      optionCount: 0,
      optionCurrentPage: 1,
      optionPageCount: 4,
      activeOption: 0,

      //옵션 item 관련 data들
      mstItemList: jsonTbMstItem.data.mstItemList,
      itemList: [],
      itemCount: 0,
      itemCurrentPage: 1,
      itemPageCount: 14,

      // 총 옵션 금액
      totalUprc: 0,
    };
  },
  props: {
    menuObj: Object,
  },
  mounted() {
    this.initOptionList();

    if (this.optionCount == 0) {
      this.setBaskets();
      return false;
    }

    let optClasCd = this.optionList[0].optClasCd;
    this.itemList = this.mstItemList.filter(
      (item2) => item2.optClasCd == optClasCd
    );
    this.itemCount = this.itemList.length;
  },
  methods: {
    optionDetail(option, index) {
      let optClasCd = option.optClasCd;
      this.itemList = this.mstItemList.filter(
        (item2) => item2.optClasCd == optClasCd
      );
      this.itemCount = this.itemList.length;

      this.activeOption = index;
    },
    selectItem(item) {
      let optionObj =
        this.optionList[
          (this.optionCurrentPage - 1) * this.optionPageCount +
            this.activeOption
        ];

      if (optionObj.selectItemCd == item.optItemCd) {
        delete optionObj.selectItemCd;
        delete optionObj.selectItemNm;
        delete optionObj.selectItemPrice;
        delete optionObj.selectItemCnt;
        delete optionObj.selectItemDiscount;

        this.totalUprc -= item.saleUprc;
        return false;
      }

      this.totalUprc +=
        item.saleUprc -
        (optionObj.selectItemPrice == null ? 0 : optionObj.selectItemPrice);

      optionObj.selectItemCd = item.optItemCd;
      optionObj.selectItemNm = item.presetNm;
      optionObj.selectItemPrice = item.saleUprc;
      optionObj.selectItemDiscount = 0;
      optionObj.selectItemCnt = 1;
    },
    initOptionList() {
      this.optionList = JSON.parse(
        JSON.stringify(
          this.mstOptionList.filter(
            (item) =>
              item.optGrpCd == this.menuObj.optGrpCd && item.optGbn != "03"
          )
        )
      );
      this.optionCount = this.optionList.length;
      this.totalUprc = 0;
    },
    setBaskets() {
      let tempList = this.optionList.filter(
        (item) => item.selectItemCd != null
      );
      console.log(tempList)
      this.$emit("setBasketOrder", tempList);
      this.$.emit("close");
    },
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


